<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <a class="navbar-brand" target="_blank" href="http://www.lasistemas.com">
    <img src="../../../../assets/img/logo.png" width="260" height="28" class="d-inline-block align-top" alt="">
  </a>
  <span class="navbar-text">
    {{ autenticaCli.CadOut.Nombrecli }}
  </span>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <i class="fa fa-bars"></i>
  </button>
  <div class="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
    <ul class="navbar-nav">
      <li class="nav-item active">
        <a class="nav-link" routerLink=""> <i class="fa fa-home"></i> Inicio</a>
      </li>
      <li class="nav-item active">
        <a class="nav-link" routerLink="/casos"><i class="fa fa-list"></i> Casos</a>
      </li>
      <li class="nav-item active">
        <a class="nav-link" routerLink="/mejoras"><i class="fa fa-desktop"></i> Mejoras</a>
      </li>
      <li class="nav-item active">
        <a class="nav-link" routerLink="/visitasCliente"><i class="fa fa-address-card"></i> Visitas Cliente</a>
      </li>
      <li class="nav-item dropdown active">
        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-user"></i> {{ autenticaCli.CadOut.Nombre }}
        </a>
        <div class="dropdown-menu navbar-dark bg-dark" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item" routerLink="/cambiacl">Modificar Password</a>
          <a class="dropdown-item" (click)="closeApp()">Cerrar Sesión</a>
        </div>
      </li>
    </ul>
  </div>
</nav>
